// extracted by mini-css-extract-plugin
module.exports =  {"alert":"vwMY2V75VHaHIKtL93tO"};